// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ee4ea33c","453":"5b111ae8","455":"38612900"}[chunkId] + ".chunk.js";
};